import { render, staticRenderFns } from "./subscriptionseller.vue?vue&type=template&id=36fe80ba&scoped=true&"
import script from "./subscriptionseller.vue?vue&type=script&lang=js&"
export * from "./subscriptionseller.vue?vue&type=script&lang=js&"
import style0 from "./subscriptionseller.vue?vue&type=style&index=0&id=36fe80ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe80ba",
  null
  
)

export default component.exports